import { loadGuessedIatas, localDateIso } from "./game";

// When the classic game offers Daily Service to its players: to anyone who
// has not played today's puzzle. The button is there every time; the sheet
// rises at most once a day.

const SHEET_SHOWN_KEY = "fg_daily_promo_shown";
// Where the daily game remembers the puzzle it last loaded (useDailyData).
const PUZZLE_CACHE_KEY = "fg_daily_cache_puzzle";

// The dates today's puzzle may be saved under. Usually today's own date, but
// on a missed day the previous puzzle is served again under its own date.
const todaysPuzzleDates = (): string[] => {
  const today = localDateIso();
  const dates = [today];
  try {
    const cached = JSON.parse(localStorage.getItem(PUZZLE_CACHE_KEY) ?? "null");
    const puzzleDate = cached?.date === today ? cached.data?.date : null;
    if (typeof puzzleDate === "string" && puzzleDate !== today) dates.push(puzzleDate);
  } catch {
    // Nothing remembered, or not readable: today's own date is enough.
  }
  return dates;
};

// True once at least one guess has gone in on today's puzzle.
const hasPlayedToday = (): boolean =>
  todaysPuzzleDates().some((date) => loadGuessedIatas(date).length > 0);

export const shouldOfferDaily = (): boolean => {
  try {
    return !hasPlayedToday();
  } catch {
    return false;
  }
};

export const shouldShowDailySheet = (): boolean => {
  try {
    return shouldOfferDaily() && localStorage.getItem(SHEET_SHOWN_KEY) !== localDateIso();
  } catch {
    return false;
  }
};

export const markDailySheetShown = (): void => {
  try {
    localStorage.setItem(SHEET_SHOWN_KEY, localDateIso());
  } catch {
    // Storage blocked: nothing to remember it with.
  }
};
